/**
 * i18n Foundation (iter103)
 * =========================
 * `react-i18next` mit Browser-Language-Detection + localStorage-Persistenz.
 *
 * Ausnahme: Das Admin-Dashboard ist IMMER Deutsch. Dazu wird beim Mounten der
 * Admin-Routen die Sprache temporär auf `de` gezwungen (siehe `useAdminLangGuard`).
 *
 * Migrations-Strategie:
 * 1. Neue Strings landen in `de.json` (Baseline) + `en.json` + `nl.json`.
 * 2. Bestehende deutsche Hardcodes bleiben Deutsch — werden beim nächsten Touch
 *    on-the-fly nach t()-Schlüsseln migriert.
 * 3. `useTranslation()` in allen Public-Facing-Pages.
 *
 * iter106 (2026-07-19): Katalog-Namespace (MP-Kategorien, STX-Kategorien,
 * Attribute) unter `catalog.*` gemergt.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";
import nl from "./locales/nl.json";
import catalogDe from "./locales/catalog-de.json";
import catalogEn from "./locales/catalog-en.json";
import catalogNl from "./locales/catalog-nl.json";

export const SUPPORTED_LANGS = [
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: { ...de, catalog: catalogDe } },
      en: { translation: { ...en, catalog: catalogEn } },
      nl: { translation: { ...nl, catalog: catalogNl } },
    },
    fallbackLng: "de",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    nonExplicitSupportedLngs: true, // en-US → en, nl-BE → nl
    load: "languageOnly",           // ignoriert Region-Codes vollständig
    interpolation: {
      escapeValue: false,  // React escaped bereits
    },
    detection: {
      // 1. Vorherige Wahl im localStorage → 2. Browser-Sprache (navigator.languages) →
      // 3. htmlTag → fallback DE.
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "stx_lang",
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) => {
        // Sicherheitsnetz: normalisiere Region-Codes auf reine Sprache
        if (!lng) return lng;
        return lng.toLowerCase().split("-")[0];
      },
    },
    saveMissing: false,
    returnEmptyString: false,
  });

export default i18n;
